import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import TableView from 'next/javascripts/components/table-view/element';

Component('tr-spreadsheet', {
  extends: [TableView],
  mixins: [eventListenerMixin],

  properties: {
    errors: {
      type: Object,
      default: {},
    },
  },

  ready() {
  },

  getValue() {
    const data = this.handsontable.getData();
    return data.filter((_, index) => !this.handsontable.isEmptyRow(index));
  },

  setResult() {
    const parsedValue = this.getValue().map((row) => {
      this.selectColumnIndices.forEach((selectIndex) => {
        let rowValue = '';
        let columnValue = '';

        try {
          rowValue = JSON.parse(row[selectIndex]);
        } catch {
          return;
        }
        if (rowValue === null) return;

        if (this.columns[selectIndex].multiple) {
          columnValue = rowValue.map(option => option.text).join(',');
        } else {
          columnValue = rowValue.text;
        }
        // eslint-disable-next-line no-param-reassign
        row[selectIndex] = columnValue;
      });
      return row;
    });
    this.result.value = JSON.stringify(parsedValue);
  },

  selectNextErrorCell() {
    this.currentErrorIndex = this.currentErrorIndex % this.errors.length;
    const [row, col] = Object.keys(this.parsedErrors)[this.currentErrorIndex].split('-');
    this.handsontable.selectCell(parseInt(row, 10), parseInt(col, 10));
    this.currentErrorIndex += 1;
  },

  afterInitHandsontable() {
    this.handsontable.addHook('afterChange', this.setResult.bind(this));
    this.handsontable.addHook('afterRemoveCol', this.setResult.bind(this));
    this.handsontable.addHook('afterRemoveRow', this.setResult.bind(this));
    this.handsontable.addHook('beforeRenderer', this.handleBeforeRenderer.bind(this));
    this.handsontable.addHook('beforeChangeRender', this.handleBeforeChangeRender.bind(this));

    this.parseErrors();
    this.result = this.querySelector('.result-input');
    this.selectColumnIndices = this.columns.reduce((indices, column, index) => (column.editor === 'select' ? indices.concat(index) : indices), []);
    this.handsontable.render();
  },

  handleBeforeChangeRender(changes) {
    changes.forEach((change) => {
      const [row, prop, oldValue, newValue] = change;
      const col = this.handsontable.propToCol(prop);
      const key = `${row}-${col}`;
      if (this.parsedErrors[key] && oldValue !== newValue) {
        const cellMeta = this.handsontable.getCellMeta(row, col);
        cellMeta.valid = true;
        delete this.parsedErrors[key];
        this.namespacedTrigger('invalidChecked', { detail: Object.keys(this.parsedErrors).length });
      }
    });
  },

  handleBeforeRenderer(element, row, column, prop, value, cellProperties) {
    const key = `${row}-${column}`;
    if (this.parsedErrors[key]) {
      // eslint-disable-next-line no-param-reassign
      element.dataset.errorMessage = this.parsedErrors[key];
      // eslint-disable-next-line no-param-reassign
      cellProperties.valid = false;
    }
  },

  parseErrors() {
    this.parsedErrors = {};
    this.currentErrorIndex = 0;
    this.errors.forEach((element) => {
      this.parsedErrors[`${element.row}-${element.col}`] = element.message;
    });
  },
});
